import { action, autorun, observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import LeafletMap from '../../LeafletMap';
import { getCenter } from '../../Map/getCenterLatLng';
import Spinner from '../../Spinner';
import _ from 'lodash';
import { hashHistory } from 'react-router'
import DataFilter from '../../StationFilter';

@inject('mapStore', 'hydroMeteoStore', 'stationStore')
@observer
class RainfallMap extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedStationIds: [],
    };
  }

  @observable selectedMarker = null;
  @observable markers = [];

  @action onMarkerOver = marker => this.selectedMarker = marker.station_id;

  componentWillMount() {
    const { mapStore } = this.props;
    if (!mapStore.stations.length && !mapStore.loadingMarkers) mapStore.fetchMapMarkers();
  }

  onMarkerClick = marker => {
    hashHistory.push(`/analysis/meteorological/rainfall-map/${marker.station_id}`)
  }

  handleSelectedStationIdsChange = (selectedStationIds) => {
    this.setState({ selectedStationIds });
  }

  applyFilters(markers) {
    const { selectedStationIds } = this.state;
    return selectedStationIds.length > 0 ? markers.filter((item) => selectedStationIds.includes(item.station_id)) : [];
  }

  getPopupBox = marker => {
    if (!marker) {
      return null;
    }
    let station = this.props.stationStore.findById(marker.station_id);
    let district = station.meta_data.find(item => item.name.trim() === 'District');
    let division = station.meta_data.find(item => item.name.trim() === 'Division');
    let subDivision = station.meta_data.find(item => item.name.trim() === 'Sub-Division');
    let identifier = station.meta_data.find(item => item.name.trim() === 'ffwc_Identifier');

    return <div id={'rainfall_marker-' + marker.id + '-popup'} style={{ maxHeight: '400px' }}>
      <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{marker.station.name}</div>
      <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }} onClick={() => this.selectedMarker = null} />
      <br />
      <div className='DataTable'>
        <table>
          <tbody>
            <tr><th>District</th><td>{!!district ? district.value : '-'}</td></tr>
            <tr><th>Basin</th><td></td></tr>
            <tr><th>Division</th><td>{!!division ? division.value : '-'}</td></tr>
            <tr><th>Sub Division</th><td>{!!subDivision ? subDivision.value : '-'}</td></tr>
            <tr><th>FFWC Identifier</th><td>{!!identifier ? identifier.value : '-'}</td></tr>
            <tr><th>Rainfall 10M</th><td>{!!marker.rainfall_10m ? marker.rainfall_10m.value : '-'}</td></tr>
            <tr><th>Rainfall 1HR</th><td>{!!marker.rainfall_1h ? marker.rainfall_1h.value : '-'}</td></tr>
          </tbody>
        </table>
      </div>
      <div className='full-width flex flex-row justify-center'>
        <button className='button' onClick={() => this.onMarkerClick(marker)}>Rainfall Cummulative Graph</button>
      </div>
    </div>
  }

  render() {
    const { mapStore, hydroMeteoStore, stationStore } = this.props;

    if (mapStore.loadingMarkers || stationStore.isLoading) return <Spinner />;

    let markers = hydroMeteoStore.rainfallMarkers;
    markers = this.applyFilters(markers);
    const mapCenter = getCenter(markers);

    return (
      <div>
         <DataFilter onSelectedStationIdsChange={this.handleSelectedStationIdsChange} />
         <div className='inline-it'>
        <LeafletMap
          id='rainfall_map'
          markers={markers}
          center={mapCenter}
          isLoading={mapStore.loadingMarkers}
          height='55vh'
          onMarkerClick={this.onMarkerClick}
          onMarkerOver={this.onMarkerOver}>
          {this.selectedMarker ? <div
            className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +this.selectedMarker))}</div> : null}
        </LeafletMap>
        <div className='rainfall-indicator-legend'>
          {hydroMeteoStore.rainfallRange.map((item, i) => <div key={`rainfall-indicator-item-${i}`} className='rainfall-indicator-legend-item'>
            <span style={{ background: item.color }} />
            <p>{item.label}</p>
          </div>)}
        </div>
      </div>
      </div>
    );
  }

}

export default RainfallMap;


// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/RainfallMap.js